import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { StoredSection } from '@/entities/templates';

import { templateEditorMessages } from '../../config';

import styles from './SectionNav.module.scss';

type SectionNavProps = {
  sections: StoredSection[];
  activeSectionIndex: number | null;
  className?: string;
  onSelect: (sectionIndex: number) => void;
};

export const SectionNav: FC<SectionNavProps> = (props) => {
  const { sections, activeSectionIndex, className, onSelect } = props;

  const { formatMessage } = useIntl();

  return (
    <nav
      className={cn(styles.container, className)}
      data-component="template-section-nav"
    >
      {sections.map((section, sectionIndex) => {
        const isActive = activeSectionIndex === sectionIndex;

        return (
          <button
            key={`${section.code}-${sectionIndex}`}
            type="button"
            className={cn(styles.item, isActive && styles.itemActive)}
            onClick={() => onSelect(sectionIndex)}
          >
            <span className={styles.number}>{`${sectionIndex + 1}.`}</span>
            <span className={styles.title}>
              {section.title ||
                formatMessage(templateEditorMessages.sectionTitle)}
            </span>
          </button>
        );
      })}
    </nav>
  );
};
